(() => {
  const canonicalHandle = document.body.dataset.canonicalProduct || 'fruit-rolls-variety-pack';
  const copy = {
    bagLabel: document.body.dataset.cartBagLabel || 'Bag',
    productLabel: document.body.dataset.cartProductLabel || 'Variety Pack',
    flavourSummary: document.body.dataset.cartFlavourSummary || 'Mango Lime · Beet Karkade · Melon Mint',
    removeLabel: document.body.dataset.cartRemoveLabel || 'Remove',
    emptyTitle: document.body.dataset.cartEmptyTitle || 'Your bag is empty.',
    emptyCopy: document.body.dataset.cartEmptyCopy || 'The Variety Pack is ready when you are.',
    emptyLinkLabel: document.body.dataset.cartEmptyLinkLabel || 'Explore the Variety Pack',
    addedMessage: document.body.dataset.cartAddedMessage || 'Fruit Rolls Variety Pack added to your bag.',
    addErrorMessage: document.body.dataset.cartAddErrorMessage || 'The Variety Pack could not be added. Please try again.',
    updateMessage: document.body.dataset.cartUpdateMessage || 'Bag quantity updated.',
    removedMessage: document.body.dataset.cartRemovedMessage || 'Item removed from your bag.',
    updateErrorMessage: document.body.dataset.cartUpdateErrorMessage || 'Your bag could not be updated. Please try again.',
    loadErrorMessage: document.body.dataset.cartLoadErrorMessage || 'We could not load your bag. Please try again.',
  };
  const shell = document.querySelector('[data-cart-shell]');
  const drawer = document.querySelector('.sf-cart-drawer');
  const drawerBody = document.querySelector('[data-cart-drawer-body]');
  const drawerFooter = document.querySelector('[data-cart-drawer-footer]');
  const status = document.querySelector('[data-cart-status]');
  let returnFocus = null;
  let closeTimer = null;

  const escapeHtml = (value) => String(value ?? '').replace(/[&<>'"]/g, (char) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
  })[char]);

  const money = (cents) => new Intl.NumberFormat('en-EG', {
    style: 'currency', currency: 'EGP', maximumFractionDigits: 0
  }).format(Number(cents || 0) / 100).replace('EGP', 'EGP ');

  const announce = (message) => {
    if (!status) return;
    status.textContent = '';
    window.setTimeout(() => { status.textContent = message; }, 20);
  };

  const request = async (url, options = {}) => {
    const response = await fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json', ...(options.headers || {}) },
      ...options
    });
    if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
    return response.json();
  };

  const setCounts = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = count; });
    document.querySelectorAll('.d17-head__bag[data-cart-toggle]').forEach((node) => {
      node.textContent = `${copy.bagLabel} · ${count}`;
      node.setAttribute('aria-label', `Open bag, ${count} ${count === 1 ? 'item' : 'items'}`);
    });
  };

  const productImage = document.body.dataset.cartImage || '';

  const renderCart = (cart) => {
    setCounts(cart.item_count);
    if (!drawerBody || !drawerFooter) return;
    if (!cart.item_count) {
      drawerBody.innerHTML = `<div class="sf-empty-state"><h2>${escapeHtml(copy.emptyTitle)}</h2><p>${escapeHtml(copy.emptyCopy)}</p><a class="sf-primary-button" href="/products/${escapeHtml(canonicalHandle)}">${escapeHtml(copy.emptyLinkLabel)}</a></div>`;
      drawerFooter.hidden = true;
      return;
    }
    drawerBody.innerHTML = cart.items.map((item) => `
      <article class="sf-drawer-line">
        <a class="sf-drawer-line__image" href="/products/${escapeHtml(canonicalHandle)}" aria-label="View ${escapeHtml(item.product_title)}">${productImage ? `<img src="${escapeHtml(productImage)}" alt="">` : ''}</a>
        <div>
          <a class="sf-eyebrow sf-cart-product-label" href="/products/${escapeHtml(canonicalHandle)}">${escapeHtml(copy.productLabel)}</a>
          <h3><a href="/products/${escapeHtml(canonicalHandle)}">${escapeHtml(item.product_title)}</a></h3>
          <p>${escapeHtml(copy.flavourSummary)}</p>
          <div class="sf-drawer-line__actions">
            <div class="sf-quantity-stepper" aria-label="Quantity for ${escapeHtml(item.product_title)}">
              <button type="button" data-cart-change="${escapeHtml(item.key)}" data-quantity="${Math.max(0, item.quantity - 1)}" aria-label="Decrease quantity">−</button>
              <strong aria-live="polite">${item.quantity}</strong>
              <button type="button" data-cart-change="${escapeHtml(item.key)}" data-quantity="${item.quantity + 1}" aria-label="Increase quantity">+</button>
            </div>
            <button class="sf-secondary-link" type="button" data-cart-change="${escapeHtml(item.key)}" data-quantity="0" aria-label="${escapeHtml(copy.removeLabel)} ${escapeHtml(item.product_title)} from bag">${escapeHtml(copy.removeLabel)}</button>
          </div>
        </div>
      </article>`).join('');
    drawerFooter.hidden = false;
    const total = drawerFooter.querySelector('[data-cart-total]');
    if (total) total.textContent = money(cart.total_price);
  };

  const renderCartPage = (cart) => {
    if (!document.body.classList.contains('sf-page--cart')) return;
    if (!cart.item_count) { window.location.reload(); return; }
    const items = new Map(cart.items.map((item) => [item.key, item]));
    document.querySelectorAll('[data-cart-page-line]').forEach((line) => {
      const item = items.get(line.dataset.lineKey);
      if (!item) { line.remove(); return; }
      const quantity = line.querySelector('[data-cart-page-quantity]');
      const linePrice = line.querySelector('[data-cart-page-line-price]');
      const buttons = line.querySelectorAll('.sf-quantity-stepper [data-cart-change]');
      if (quantity) quantity.textContent = item.quantity;
      if (linePrice) linePrice.textContent = money(item.final_line_price);
      if (buttons[0]) buttons[0].dataset.quantity = Math.max(0, item.quantity - 1);
      if (buttons[buttons.length - 1]) buttons[buttons.length - 1].dataset.quantity = item.quantity + 1;
    });
    const total = document.querySelector('[data-cart-page-total]');
    if (total) total.textContent = money(cart.total_price);
    setCounts(cart.item_count);
  };

  const getCart = async () => {
    const cart = await request('/cart.js');
    const invalidItems = cart.items.filter((item) => item.handle !== canonicalHandle);
    if (!invalidItems.length) return cart;
    const updates = Object.fromEntries(invalidItems.map((item) => [item.key, 0]));
    const cleaned = await request('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });
    announce('Unavailable soft-launch items were removed from your bag.');
    if (document.body.classList.contains('sf-page--cart')) window.location.reload();
    return cleaned;
  };

  const openDrawer = async (trigger) => {
    if (!shell || !drawer) return;
    returnFocus = trigger || document.activeElement;
    window.clearTimeout(closeTimer);
    shell.hidden = false;
    shell.setAttribute('aria-hidden', 'false');
    window.requestAnimationFrame(() => shell.classList.add('is-open'));
    document.body.classList.add('sf-cart-open');
    document.querySelectorAll('[data-cart-toggle]').forEach((node) => node.setAttribute('aria-expanded', 'true'));
    drawer.setAttribute('aria-busy', 'true');
    try { renderCart(await getCart()); }
    catch (error) { drawerBody.innerHTML = `<p>${escapeHtml(copy.loadErrorMessage)}</p>`; }
    finally { drawer.removeAttribute('aria-busy'); drawer.focus(); }
  };

  const closeDrawer = () => {
    if (!shell) return;
    shell.classList.remove('is-open');
    shell.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('sf-cart-open');
    document.querySelectorAll('[data-cart-toggle]').forEach((node) => node.setAttribute('aria-expanded', 'false'));
    closeTimer = window.setTimeout(() => { shell.hidden = true; }, 340);
    if (returnFocus instanceof HTMLElement) returnFocus.focus();
  };

  const addForm = async (form, button) => {
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try {
      await request('/cart/add.js', { method: 'POST', body: new FormData(form) });
      announce(copy.addedMessage);
      await openDrawer(button);
    } catch (error) {
      announce(copy.addErrorMessage);
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('.sf21-buy-form, .sf-product-form');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    if (button) addForm(form, button);
  });

  document.addEventListener('click', async (event) => {
    const toggle = event.target.closest('[data-cart-toggle]');
    if (toggle) { event.preventDefault(); openDrawer(toggle); return; }
    if (event.target.closest('[data-cart-close]')) { closeDrawer(); return; }
    const change = event.target.closest('[data-cart-change], [data-cart-remove]');
    if (!change) return;
    const key = change.dataset.cartChange || change.dataset.cartRemove;
    const quantity = Number(change.dataset.quantity || 0);
    change.disabled = true;
    try {
      const cart = await request('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity })
      });
      renderCartPage(cart);
      renderCart(cart);
      announce(quantity ? copy.updateMessage : copy.removedMessage);
    } catch (error) { announce(copy.updateErrorMessage); }
  });

  document.addEventListener('keydown', (event) => {
    if (!shell || shell.hidden) return;
    if (event.key === 'Escape') { closeDrawer(); return; }
    if (event.key !== 'Tab' || !drawer) return;
    const focusable = [...drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])')];
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  getCart().then(renderCart).catch(() => {});
})();
